export default {"src":"/_next/static/media/Osteoarthritis.0413cdbf.svg","height":51,"width":51,"blurWidth":0,"blurHeight":0};